import {
  ButtonSize,
  Input,
  LinkButton,
  StyledInvisibleTableHeaderCell,
  Table,
} from '@versita/frontend/campus-ui-web';
import { useGetStudentQuery } from '../../services/generated/studentPortalApi';
import { useState } from 'react';
import { useHandleQueryError } from '@versita/frontend/api-utils';

/**
 * List of student timetables with the ability to view and (un)publish them
 * subject to the user's role.
 */
export const StudentTimetableList = () => {
  const [search, setSearch] = useState<string>('');
  const { data: searchedTimetable, isFetching: isFetchingSearch } =
    useHandleQueryError(
      useGetStudentQuery({ studentId: search }, { skip: search.length < 9 }),
    );
  const timetables =
    search.length > 8 ? (searchedTimetable ? [searchedTimetable] : []) : [];
  const loading = isFetchingSearch;

  return (
    <>
      <Input
        label="Search for a Student ID"
        id="student-id-search-input"
        placeholder="Enter a student ID"
        prefix="@"
        style={{ width: 'auto' }}
        onChange={(e) =>
          setSearch('@' + e.currentTarget.value.replace('@', ''))
        }
      />
      {search.length > 8 && (
        <Table
          loading={loading}
          emptyText="No results found"
          headers={[
            'Student ID',
            'Network ID',
            'Student Name',
            'Course Name',
            <StyledInvisibleTableHeaderCell>
              Actions
            </StyledInvisibleTableHeaderCell>,
          ]}
          data={timetables.map(
            ({ studentId, studentName, courseName, networkId }) => [
              studentId,
              networkId,
              studentName,
              courseName,
              <div style={{ display: 'flex' }}>
                <LinkButton
                  $buttonSize={ButtonSize.Small}
                  to={`/admin/student-timetable/${networkId}`}
                >
                  View
                </LinkButton>
              </div>,
            ],
          )}
        />
      )}
    </>
  );
};

export default StudentTimetableList;
